import { rebind, merge } from "../utils";

import { vwap } from "../calculator";

import baseIndicator from "./baseIndicator";

const ALGORITHM_TYPE = "VWAP";

export default function () {
  const base = baseIndicator()
    .type(ALGORITHM_TYPE)
    .accessor((d) => d.vwap);

  const underlyingAlgorithm = vwap();

  const mergedAlgorithm = merge()
    .algorithm(underlyingAlgorithm)
    .merge((datum, indicator) => {
      datum.vwap = indicator;
    });

  const indicator = function (data, options = { merge: true }) {
    if (options.merge) {
      if (!base.accessor())
        throw new Error(
          `Set an accessor to ${ALGORITHM_TYPE} before calculating`,
        );
      return mergedAlgorithm(data);
    }
    return underlyingAlgorithm(data);
  };

  rebind(indicator, base, "id", "accessor", "stroke", "fill", "echo", "type");
  rebind(indicator, underlyingAlgorithm, "undefinedLength");
  rebind(indicator, underlyingAlgorithm, "options");
  rebind(indicator, mergedAlgorithm, "merge", "skipUndefined");

  return indicator;
}
